// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
// import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  history: getIcon('ic_history'),
  beacon: getIcon('ic_beacon'),
  mobile: getIcon('ic_mobile'),
  group: getIcon('ic_group'),
  checklist: getIcon('ic_checklist'),
  place: getIcon('ic_place'),
  device: getIcon('ic_devices'),
  map: getIcon('ic_map'),
  sos: getIcon('ic_sos'),
  alerts: getIcon('ic_alert'),
  roles: getIcon('ic_roles'),
  list: getIcon('ic_list'),
  time: getIcon('ic_schedule'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'activities', path: PATH_DASHBOARD.general.activitie, icon: ICONS.map },
      { title: 'activity_list', path: PATH_DASHBOARD.general.activityList, icon: ICONS.list },
      { title: 'alerts', path: PATH_DASHBOARD.general.alerts, icon: ICONS.alerts },
      { title: 'timekeeping', path: PATH_DASHBOARD.general.timekeeping, icon: ICONS.time },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
    ],
  },

  // WORK MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'work_management',
    items: [
      { title: 'schedules', path: PATH_DASHBOARD.schedules.root, icon: ICONS.calendar },
      { title: 'checklists', path: PATH_DASHBOARD.checklist.list, icon: ICONS.checklist },
      {
        title: 'places',
        path: PATH_DASHBOARD.places.root,
        icon: ICONS.place,
      },
      {
        title: 'devices',
        path: PATH_DASHBOARD.devices.root,
        icon: ICONS.device,
      },
    ],
  },

  // USER MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'user_management',
    items: [
      { title: 'roles', path: PATH_DASHBOARD.user.role.list, icon: ICONS.roles },
      { title: 'groups', path: PATH_DASHBOARD.user.group.list, icon: ICONS.group },
      { title: 'accounts', path: PATH_DASHBOARD.user.list, icon: ICONS.user },
    ],
  },

  // STATISTICS
  // ----------------------------------------------------------------------
  {
    subheader: 'statistics',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'events', path: PATH_DASHBOARD.general.events, icon: ICONS.booking },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     { title: 'schedules', path: PATH_DASHBOARD.schedules.root, icon: ICONS.calendar },
  //     { title: 'checklists', path: PATH_DASHBOARD.checklist.list, icon: ICONS.checklist },
  //     {
  //       title: 'places',
  //       path: PATH_DASHBOARD.places.root,
  //       icon: ICONS.place,
  //     },
  //     {
  //       title: 'devices',
  //       path: PATH_DASHBOARD.devices.root,
  //       icon: ICONS.device,
  //     },
  //     {
  //       title: 'users',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'roles', path: PATH_DASHBOARD.user.role.list },
  //         { title: 'groups', path: PATH_DASHBOARD.user.group.list },
  //         { title: 'accounts', path: PATH_DASHBOARD.user.list },
  //       ],
  //     },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar.root, icon: ICONS.calendar },
  //     {
  //       title: 'kanban',
  //       path: PATH_DASHBOARD.kanban,
  //       icon: ICONS.kanban,
  //     },
  //   ],
  // },
];

export default navConfig;
